import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "title", "titleTag", "description", "type", "content", "tabBarItems", "columnsConfig", "layoutType", "buttons"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo, useState } from 'react';
import { CardBasic, CardInfo } from '@sbercloud/uikit-product-site-cards';
import { Grid } from '@sbercloud/uikit-product-site-grid';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { ButtonFilled } from '@snack-uikit/button';
import { Link } from '@snack-uikit/link';
import { SectionBasic } from '../SectionBasic';
import { CardNumeric } from './components';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionBenefits(_ref) {
  var id = _ref.id,
    title = _ref.title,
    titleTag = _ref.titleTag,
    description = _ref.description,
    type = _ref.type,
    content = _ref.content,
    tabBarItems = _ref.tabBarItems,
    columnsConfig = _ref.columnsConfig,
    layoutType = _ref.layoutType,
    buttons = _ref.buttons,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(tabBarItems && tabBarItems[0].value),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var tabs = useMemo(function () {
    return tabBarItems === null || tabBarItems === void 0 ? void 0 : tabBarItems.map(function (tab) {
      return _objectSpread(_objectSpread({}, tab), {}, {
        onClick: function onClick(e) {
          var _tab$onClick;
          setActiveTab(tab.value);
          (_tab$onClick = tab.onClick) === null || _tab$onClick === void 0 ? void 0 : _tab$onClick.call(tab, e);
        }
      });
    });
  }, [tabBarItems]);
  var outline = rest.outline;
  var gap = type === 'basic' ? 'l' : 's';
  var backgroundColor = type === 'basic' || outline ? 'neutral-background1-level' : 'neutral-background';
  return /*#__PURE__*/_jsxs(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    title: title,
    titleTag: titleTag,
    description: description,
    layoutType: layoutType,
    backgroundColor: backgroundColor,
    tabBarItems: tabs
  }, extractSupportProps(rest)), {}, {
    children: [!tabBarItems && /*#__PURE__*/_jsxs(Grid, {
      layoutType: layoutType,
      columnsConfig: columnsConfig,
      gap: gap,
      children: [type === 'info' && content.map(function (item, index) {
        return /*#__PURE__*/_jsx(CardInfo, _objectSpread(_objectSpread({}, item), {}, {
          outline: outline,
          layoutType: layoutType
        }), index);
      }), type === 'numeric' && content.map(function (item, index) {
        return /*#__PURE__*/_jsx(CardNumeric, _objectSpread(_objectSpread({}, item), {}, {
          number: index + 1,
          layoutType: layoutType
        }), index);
      }), type === 'basic' && content.map(function (item, index) {
        return /*#__PURE__*/_jsx(CardBasic, _objectSpread(_objectSpread({}, item), {}, {
          layoutType: layoutType
        }), index);
      })]
    }), tabBarItems && /*#__PURE__*/_jsxs(Grid, {
      layoutType: layoutType,
      columnsConfig: columnsConfig,
      gap: gap,
      children: [type === 'info' && content.filter(function (_ref2) {
        var tabValue = _ref2.tabValue;
        return tabValue === activeTab;
      }).map(function (_ref3) {
        var cards = _ref3.cards;
        return cards.map(function (card, index) {
          return /*#__PURE__*/_jsx(CardInfo, _objectSpread(_objectSpread({
            layoutType: layoutType
          }, card), {}, {
            outline: outline
          }), index);
        });
      }), type === 'numeric' && content.filter(function (_ref4) {
        var tabValue = _ref4.tabValue;
        return tabValue === activeTab;
      }).map(function (_ref5) {
        var cards = _ref5.cards;
        return cards.map(function (card, index) {
          return /*#__PURE__*/_jsx(CardNumeric, _objectSpread(_objectSpread({
            layoutType: layoutType
          }, card), {}, {
            number: index + 1
          }), index);
        });
      }), type === 'basic' && content.filter(function (_ref6) {
        var tabValue = _ref6.tabValue;
        return tabValue === activeTab;
      }).map(function (_ref7) {
        var cards = _ref7.cards;
        return cards.map(function (card, index) {
          return /*#__PURE__*/_jsx(CardBasic, _objectSpread({
            layoutType: layoutType
          }, card), index);
        });
      })]
    }), buttons && /*#__PURE__*/_jsx("div", {
      className: styles.buttons,
      children: buttons.map(function (button) {
        return button.href ? /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, button), {}, {
          text: button.label,
          size: "l",
          insideText: true
        }), button.label) : /*#__PURE__*/_jsx(ButtonFilled, _objectSpread({
          size: "l"
        }, button), button.label);
      })
    })]
  }));
}